import { IDocumentImage } from '@wix/client-search-sdk';

export const getImageSrc = (image: NonNullable<IDocumentImage>): string =>
  'src' in image ? image.src : image.name;
